import { render, staticRenderFns } from "./Unos.vue?vue&type=template&id=213bd143&scoped=true"
import script from "./Unos.vue?vue&type=script&lang=js"
export * from "./Unos.vue?vue&type=script&lang=js"
import style0 from "./Unos.vue?vue&type=style&index=0&id=213bd143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bd143",
  null
  
)

export default component.exports